import { render, staticRenderFns } from "./PlatformElderByAssessmentAbilityAssessment.vue?vue&type=template&id=6e48e0b2&scoped=true&"
import script from "./PlatformElderByAssessmentAbilityAssessment.vue?vue&type=script&lang=js&"
export * from "./PlatformElderByAssessmentAbilityAssessment.vue?vue&type=script&lang=js&"
import style0 from "./PlatformElderByAssessmentAbilityAssessment.vue?vue&type=style&index=0&id=6e48e0b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e48e0b2",
  null
  
)

export default component.exports